import enLocale from "date-fns/locale/en-US";
import ruLocale from "date-fns/locale/ru";
import ukLocale from "date-fns/locale/uk";
import esLocale from "date-fns/locale/es";
import trLocale from "date-fns/locale/tr";
import koLocale from "date-fns/locale/ko";
import elLocale from "date-fns/locale/el";
import frLocale from "date-fns/locale/fr";
import ptLocale from "date-fns/locale/pt";
import thLocale from "date-fns/locale/th";
import viLocale from "date-fns/locale/vi";
import idLocale from "date-fns/locale/id";
import arLocale from "date-fns/locale/ar";

export interface ILocaleConfig {
  locale: any;
  format: string;
  formatChart: string;
  month: string;
  fullFormat: string;
  fullFormatWithOutSeconds: string;
  shortDateFormat: string;
  longDateFormat: string;
}

export interface ILocaleMap {
  [key: string]: ILocaleConfig;
}

export const localeMap: ILocaleMap = {
  en: {
    locale: enLocale,
    format: "MM/dd/yyyy",
    formatChart: "MM/dd/yy",
    month: "MMM yy",
    fullFormat: "MM/dd/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "MM/dd/yyyy HH:mm",
    shortDateFormat: "MMM dd, yyyy",
    longDateFormat: "MMMM dd, yyyy",
  },
  ru: {
    locale: ruLocale,
    format: "dd.MM.yyyy",
    formatChart: "dd.MM.yy",
    month: "MMM yy",
    fullFormat: "dd.MM.yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd.MM.yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  uk: {
    locale: ukLocale,
    format: "dd.MM.yyyy",
    formatChart: "dd.MM.yy",
    month: "MMM yy",
    fullFormat: "dd.MM.yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd.MM.yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  es: {
    locale: esLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  tr: {
    locale: trLocale,
    format: "dd.MM.yyyy",
    formatChart: "dd.MM.yy",
    month: "MMM yy",
    fullFormat: "dd.MM.yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd.MM.yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  ko: {
    locale: koLocale,
    format: "yyyy.MM.dd",
    formatChart: "yy.MM.dd",
    month: "yy MMM",
    fullFormat: "yyyy.MM.dd HH:mm:ss",
    fullFormatWithOutSeconds: "yyyy.MM.dd HH:mm",
    shortDateFormat: "yyyy, MMM dd",
    longDateFormat: "yyyy, MMMM dd",
  },
  el: {
    locale: elLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  fr: {
    locale: frLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  pt: {
    locale: ptLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
  th: {
    locale: thLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMM, yyyy",
  },
  vi: {
    locale: viLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMM, yyyy",
  },
  id: {
    locale: idLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMM, yyyy",
  },
  ar: {
    locale: arLocale,
    format: "dd/MM/yyyy",
    formatChart: "dd/MM/yy",
    month: "MMM yy",
    fullFormat: "dd/MM/yyyy HH:mm:ss",
    fullFormatWithOutSeconds: "dd/MM/yyyy HH:mm",
    shortDateFormat: "dd MMM, yyyy",
    longDateFormat: "dd MMMM, yyyy",
  },
};

export const getLocaleConfig = (language: string): ILocaleConfig => {
  return localeMap[language] || localeMap.en;
};
